import {TextButton} from '../../index'
import NavigateNextIcon from '@mui/icons-material/NavigateNext';

const NextButton = ({className, onClick, disabled}) => {
    return (
        <TextButton className={className} clickHandler={onClick} endIcon={<NavigateNextIcon/>} disabled={disabled}>Next</TextButton>
    )
}

export default NextButton
